import { render, staticRenderFns } from "./r-currency-kind-dialog.vue?vue&type=template&id=4fb8a61a&scoped=true"
import script from "./r-currency-kind-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-kind-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-kind-dialog.vue?vue&type=style&index=0&id=4fb8a61a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb8a61a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb8a61a')) {
      api.createRecord('4fb8a61a', component.options)
    } else {
      api.reload('4fb8a61a', component.options)
    }
    module.hot.accept("./r-currency-kind-dialog.vue?vue&type=template&id=4fb8a61a&scoped=true", function () {
      api.rerender('4fb8a61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-kind/r-currency-kind-dialog.vue"
export default component.exports